import React, { useState } from "react"
import { TextField } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { useAppLocalization } from "../../../../modules/localization/components/AppLocalizationProvider"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"

const useStyles = makeStyles()(() => ({
    input: {
        width: "20rem",
    },
}))

type StandardLast4NumbersFilterProps = Readonly<{
    value?: string
    onChange: (value?: string) => void
}>

export function StandardLast4NumbersFilter({ value, onChange }: StandardLast4NumbersFilterProps) {
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()
    const [error, setError] = useState<string | null>(null)

    const validateNumber = (value: string) => {
        if (value === "") {
            return null
        }

        if (!/^\d{4}$/.test(value)) {
            return l10n.getString("standard-last-4-numbers-filter-error-message")
        }
        return null
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        onChange(value)
        const validationError = validateNumber(value)
        setError(validationError)
    }

    return (
        <LocalizedStrict id="standard-last-4-numbers-filter" attrs={{ label: true }}>
            <TextField
                className={classes.input}
                error={!!error}
                helperText={error}
                name="creditCardLast4"
                label="Credit card, last 4 digits"
                value={value}
                onChange={handleChange}
            />
        </LocalizedStrict>
    )
}
